import { Language } from '#root/store/types';

const restrictedPaths = ['_error']; // Used in dev env to debug error pages.

export const idParamIsParty = (id: string) => {
  const languages = Object.values(Language);

  return !languages.includes(id as Language) && !restrictedPaths.includes(id);
};
